export default __webpack_public_path__ + "assets/svg-sprite.89a6a9530e414f3e0943b0a15ca42aa5.svg";